import { Role } from '@caresend/types';
import { defineComponent, computed, ref, watch, onMounted, onUnmounted } from 'vue';
import truckIcon from '../../../../../../../assets/icons/truck.svg.js';
import __vue_component__$2 from '../../../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__ from '../../../../../dev/AdvancedSettingsButton/AdvancedSettingsButton.vue.js';
import __vue_component__$1 from './AuthMenu.vue.js';
import { isRoleIncluded } from './model.js';
import __vue_component__$4 from './SessionManager.vue.js';
import __vue_component__$3 from '../../../../../../ui/Icon.vue.js';
import { useMediaQuery, getElementAutoSize } from '../../../../../../../composables/dom.js';
import '@caresend/utils';
import { getStore } from '../../../../../../../store/helpers/initStore.js';
import { getRouter, getRoute } from '../../../../../../../router/helpers/initRouter.js';
import 'immutability-helper';
import '../../../../../../../router/routes/dev/model.js';
import '../../../../../../../router/routes/dev/routes.js';
import '../../../../../../../router/routes/dashboard/model.js';
import '../../../../../../../router/routes/pro/model.js';
import '../../../../../../../router/routes/visitsPage/model.js';
import '../../../../../../../router/routes/orderFlow/model.js';
import '../../../../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../../../../router/routes/orderFlow/routes.js';
import '../../../../../../../router/routes/schedulingFlow/model.js';
import '../../../../../../../router/routes/schedulingFlow/routes.js';
import '../../../../../../../router/routes/chartingFlow/model.js';
import '../../../../../../../router/routes/chartingFlow/routes.js';
import '../../../../../../../router/routes/portal/portalRoutes.js';
import { portalOrdersRoute, portalJobsRoute } from '../../../../../../../router/routes/portal/locations.js';
import '../../../../../../../router/routes/portal/model.js';
import '../../../../../../../router/routes/visitsPage/routes.js';
import '../../../../store/portal/sessionStore.js';
import 'file-saver';
import '../../../../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../../../../database/encryption/model.js';
import 'js-sha256';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../../../../store/storeUtilities/dbSync/dbSyncStore.js';
import '../../../../../../../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../../../../../database/firebaseConfig/init.js';
import '../../../../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../../../../../functions/configuration/icons.js';
import '../../../../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../../../../functions/tracking/index.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import '../../../../../dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../../../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../../../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../../../../../store/modules/chartingFlow/model.js';
import '../../../../../../../store/modules/office/index.js';
import '../../../../../VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../../../../../store/modules/office/model.js';
import '../../../../../../../store/modules/orderFlow/index.js';
import '../../../../../../../store/modules/procedures/model.js';
import '../../../../../../../store/modules/schedulingFlow/index.js';
import '../../../../../../../store/modules/schedulingFlow/model.js';

var script = defineComponent({
    name: 'Navigator',
    components: {
        AdvancedSettingsButton: __vue_component__,
        AuthMenu: __vue_component__$1,
        ButtonComponent: __vue_component__$2,
        Icon: __vue_component__$3,
        SessionManager: __vue_component__$4,
    },
    props: {
        customRouteOptions: {
            type: Array,
            default: () => [],
        },
        authActions: {
            type: Array,
            default: () => [],
        },
    },
    setup(props) {
        const routeOptions = computed(() => {
            const options = [...props.customRouteOptions];
            if (options.length)
                return options;
            options.push({
                label: 'Orders',
                icon: 'user-md',
                to: portalOrdersRoute(),
                roles: {
                    exclude: [Role.NURSE],
                },
            });
            options.push({
                label: 'Jobs',
                svg: truckIcon,
                scale: 0.6,
                to: portalJobsRoute(),
            });
            return options;
        });
        const router = getRouter();
        const currentRoute = getRoute();
        const store = getStore();
        const shouldDisplayRoute = (route) => {
            var _a;
            if (!route.roles)
                return true;
            const userRole = (_a = store.state.auth.user) === null || _a === void 0 ? void 0 : _a.role;
            if (!userRole)
                return false;
            return isRoleIncluded(userRole, route.roles);
        };
        const isCurrentRoute = (route) => {
            if (typeof route.to === 'string')
                return route.to === currentRoute.value.path;
            return currentRoute.value.name === route.to.name
                || currentRoute.value.path === route.to.path;
        };
        const getRouteClass = (
        // vue-tsc doesn’t like when we mess around with Component types in the template
        route) => {
            const classNames = [];
            if (isCurrentRoute(route)) {
                classNames.push('Navigator__route-option--selected');
            }
            return classNames;
        };
        const navigateTo = (to) => {
            let path;
            let name;
            if (typeof to === 'string') {
                path = to;
            }
            else if (to === null || to === void 0 ? void 0 : to.name) {
                name = to.name;
            }
            if ((name && currentRoute.value.name === name)
                || (path && currentRoute.value.path === path)) {
                return;
            }
            if (!to)
                return;
            router.push(to);
        };
        const isUserNurse = computed(() => { var _a; return ((_a = store.state.auth.user) === null || _a === void 0 ? void 0 : _a.role) === Role.NURSE; });
        const isExpanded = ref(false);
        const navigatorClassNames = computed(() => {
            const classNames = [];
            if (isExpanded.value) {
                classNames.push('Navigator--expanded');
            }
            return classNames;
        });
        watch(() => currentRoute.value.name, (newName, oldName) => {
            if (newName === oldName)
                return;
            isExpanded.value = false;
        });
        const isMobile = useMediaQuery('mobile').matches;
        watch(isMobile, (newIsMobile) => {
            if (!newIsMobile && isExpanded.value) {
                isExpanded.value = false;
            }
        });
        const navigator = ref(null);
        // The bottom element is the element that contains the auth menu button
        // and the advanced settings button
        const bottom = ref(null);
        // The observer is used to observe the bottom element for changes in its
        // child list, so we can recalculate the width of the navigator
        // Making it a ref so we can stop observing when the component unmounts
        // and so we dont initialize it multiple times
        const bottomObserver = ref(null);
        /**
         * "interpolate-size: allow-keywords" is not supported across the board,
         * so we use the `getElementAutoSize` helper to analyze the width the
         * navigator should aspire to.
         */
        const interpretTargetWidth = () => {
            if (!navigator.value)
                return;
            const { width } = getElementAutoSize(navigator.value);
            navigator.value.style.setProperty('--navigator-expanded-width', `${Math.floor(width)}px`);
        };
        onMounted(interpretTargetWidth);
        // Wait for the bottom element to be available and then observe it for changes
        // in its child list, so we can recalculate the width of the navigator
        // This way, we can make sure to update the width when the auth menu button's
        // child elements change, AKA when the user log-in actually happens
        watch(bottom, (newBottom) => {
            if (!newBottom || bottomObserver.value)
                return;
            bottomObserver.value = new MutationObserver(() => {
                interpretTargetWidth();
            });
            bottomObserver.value.observe(newBottom, {
                childList: true,
                subtree: true,
            });
        }, { immediate: true });
        onUnmounted(() => {
            if (bottomObserver.value) {
                bottomObserver.value.disconnect();
                bottomObserver.value = null;
            }
        });
        const userHasPassword = computed(() => { var _a; return !!((_a = store.state.auth.user) === null || _a === void 0 ? void 0 : _a.passwordCreated); });
        return {
            bottom,
            getRouteClass,
            isExpanded,
            isUserNurse,
            navigateTo,
            navigator,
            navigatorClassNames,
            routeOptions,
            shouldDisplayRoute,
            userHasPassword,
        };
    },
});

export { script as default };
